import StudentCalendarView from "@/components/calendar/StudentCalendarView";
import { useAuth } from "@/contexts/AuthContext";

const StudentCalendar = () => {
  const { user } = useAuth();
  return (
    <div className="container mx-auto px-4 py-8 space-y-6">
      <header>
        <h1 className="text-3xl font-bold">Calendar</h1>
        <p className="text-muted-foreground">
          Your study sessions, tutoring, and personal events.
        </p>
      </header>
      {user?.id && <StudentCalendarView studentUserId={user.id} />}
    </div>
  );
};

export default StudentCalendar;
